import axiosInstance from "../Axios-Config/Axios-Config";
import { SETSTOREPICKUPDATE } from "../redux/features/store";
import { Dispatch } from "redux";
import Konsole from "../utils/konsole/Konsole";
export const GetPickupDate = async (dispatch:Dispatch,storeId:any) => {
  const url=`available/day/by/storeId?store_id=${storeId}`
  Konsole.log('url',url)
  try {
    const {
      data: { success,available_days },
    } = await axiosInstance.get(url);
    Konsole.log('datadatadata',success,available_days)
    if (success) {
      dispatch(SETSTOREPICKUPDATE(available_days));
    } else {
      dispatch(SETSTOREPICKUPDATE([]));
    }
  } catch (error: any) {
    Konsole.log('error',error)
    // dispatch(STOREPICKUPDATE([]));
  }
};

export const GetPickupTime = async (dispatch: Dispatch, day: string) => {
  try {
    const {
      data: { success },
    } = await axiosInstance.post("available/slot/by/currentDay", {
      current_day: day,
    });
    if (success) {
      // dispatch(STOREPICKUPTIME(day, slots));
    } else {
      // dispatch(STOREPICKUPTIME(day, []));
    }
  } catch (error: any) {
    Konsole.log('error',error)
    // dispatch(STOREPICKUPTIME(day, []));
  }
};
